import React from 'react'
import { Provider } from 'react-redux'
// import { ConnectedRouter } from 'connected-react-router'
import { ConnectedRouter } from 'react-router-redux'
import createHashHistory from 'history/createHashHistory'
import RouteWithSubRoutes from 'components/RouteWithSubRoutes'
import configureStore from '../store/configureStore'
import getRoutes from 'routes'

// Create a history of your choosing (we're using a browser history in this case)
const history = createHashHistory({ queryKey: false })

const store = configureStore(history)

const Root = () => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <div>
        {getRoutes().map((route, i) => (
          <RouteWithSubRoutes key={i} {...route} />
        ))}
      </div>
    </ConnectedRouter>
  </Provider>
)

export default Root



// WEBPACK FOOTER //
// ./src/containers/Root.prod.js